import React from "react";
import moment from "moment-timezone";
// eslint-disable-next-line import/no-unassigned-import
import "moment-duration-format";

import { TableHeader, DateTime, SleepTimeTable, ErrorMessage } from "./styles";
import TimeDateInput from "~/src/components/form-components/time-date-input";
import {
  getFormattedSleepTimeDuration,
  isSleepTimesValid,
  onSleepTimeChange
} from "./helpers";
import { RotaCheckbox } from "@teamrota/rota-design";

const DATE_FORMAT = "DD/MM/YYYY";

const SleepTime = ({
  selectedDates,
  selectedSleepTimes,
  handleShiftUpdate,
  isSleepTimesEnabled
}) => {
  const durationText = getFormattedSleepTimeDuration(selectedSleepTimes);

  const handleSleepTimeToggle = () => {
    const newSleepEnabled = !isSleepTimesEnabled;

    if (newSleepEnabled) {
      // Always extend shift to next day when sleep times are enabled
      const extendedTimes = {};
      selectedDates.forEach(date => {
        const key = moment(date.startTime).format(DATE_FORMAT);
        const newEndTime = moment(date.endTime)
          .clone()
          .add(
            moment(date.startTime).isSame(moment(date.endTime), "day") ? 1 : 0,
            "days"
          );

        extendedTimes[key] = {
          ...date,
          endTime: newEndTime.toDate()
        };
      });

      const update = {
        isSleepTimesEnabled: newSleepEnabled,
        times: extendedTimes
      };

      // Initialize default sleep times (23:00 - 07:00) if they are null (e.g. on agent login)
      if (
        selectedSleepTimes.startTime === null ||
        selectedSleepTimes.endTime === null
      ) {
        update.selectedSleepTimes = {
          startTime: moment()
            .month(0)
            .date(1)
            .hour(23)
            .minute(0)
            .second(0),
          endTime: moment()
            .month(0)
            .date(1)
            .hour(7)
            .minute(0)
            .second(0)
            .add(1, "days")
        };
      }

      handleShiftUpdate(update);
    } else {
      handleShiftUpdate({
        isSleepTimesEnabled: newSleepEnabled
      });
    }
  };

  return (
    <div>
      <RotaCheckbox
        label={"Add sleep times"}
        isChecked={isSleepTimesEnabled}
        onClick={handleSleepTimeToggle}
      />
      {isSleepTimesEnabled && (
        <div>
          <SleepTimeTable cellPadding={0} cellSpacing={0}>
            <tbody>
              <tr>
                <td />
                <td>
                  <TableHeader>Start</TableHeader>
                </td>
                <td />
                <td>
                  <TableHeader>End</TableHeader>
                </td>
                <td>
                  <TableHeader>Duration</TableHeader>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <DateTime>
                    <TimeDateInput
                      isSmall
                      isBorderless
                      type="time"
                      onChange={val =>
                        onSleepTimeChange(
                          handleShiftUpdate,
                          "startTime",
                          selectedSleepTimes,
                          val
                        )
                      }
                      value={moment(selectedSleepTimes.startTime).format(
                        "HH:mm"
                      )}
                    />
                  </DateTime>
                </td>
                <td>
                  <p style={{ margin: "0 5px" }}>-</p>
                </td>
                <td>
                  <DateTime>
                    <TimeDateInput
                      isSmall
                      isBorderless
                      type="time"
                      onChange={val => {
                        onSleepTimeChange(
                          handleShiftUpdate,
                          "endTime",
                          selectedSleepTimes,
                          val
                        );
                      }}
                      value={moment(selectedSleepTimes.endTime).format("HH:mm")}
                    />
                  </DateTime>
                </td>
                <td>{durationText}</td>
              </tr>
            </tbody>
            {!isSleepTimesValid(selectedDates, selectedSleepTimes) && (
              <ErrorMessage>
                Sleep time can't be outside of the shift
              </ErrorMessage>
            )}
          </SleepTimeTable>
        </div>
      )}
    </div>
  );
};

export default SleepTime;
